import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Container } from 'reactstrap';
import './header.css';

import { navLinks } from '../../assets/fake-data/navLink';

// export const navLinks = [
//     {
//         display: 'Home',
//         url: '/',
//     },
//     {
//         display: 'Menu',
//         url: 'menu',
//     },
//     {
//         display: 'Recipe',
//         url: 'recipe',
//     },
//     {
//         display: 'About',
//         url: 'about',
//     },
//     {
//         display: 'Contact',
//         url: 'contact',
//     },
// ];

const Header = () => {
    const [showMenuMobile, setshowMenuMobile] = useState(false);

    const menuMobileRef = useRef();

    useEffect(() => {
        showMenuMobile
            ? menuMobileRef.current.classList.add('toggleMenu')
            : menuMobileRef.current.classList.remove('toggleMenu');
    }, [showMenuMobile]);

    return (
        <header className="header">
            <Container>
                <div className="nav">
                    <NavLink to="/" className="nav__logo" title="Chef Food - Home">
                        <h2 className="d-flex align-item-center gap-1">
                            <span>
                                <i className="ri-restaurant-fill"></i>
                            </span>
                            Chef Food
                        </h2>
                    </NavLink>

                    <div ref={menuMobileRef} className="nav__right">
                        <div className="nav__menu">
                            <ul className="nav__list">
                                {navLinks.map((item, i) => (
                                    <NavLink
                                        onClick={() => setshowMenuMobile(false)}
                                        key={i}
                                        to={item.url}
                                        className={({ isActive }) =>
                                            isActive ? 'active' : undefined
                                        }
                                    >
                                        <li className="nav__item">{item.display}</li>
                                    </NavLink>
                                ))}
                            </ul>
                        </div>

                        <div className="nav__search">
                            <div className="search__input">
                                <input type="text" placeholder="Search item..." />
                                <span>
                                    <i className="ri-search-line"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <Link to="/" className="cart__icon" title="Cart">
                        <span>
                            <i className="ri-shopping-basket-line"></i>
                        </span>
                    </Link>
                    <div
                        onClick={() => setshowMenuMobile((prev) => !prev)}
                        className="mobile__menu"
                    >
                        <span>
                            <i className={showMenuMobile ? 'ri-close-fill' : 'ri-menu-line'}></i>
                        </span>
                    </div>
                </div>
            </Container>
        </header>
    );
};

export default Header;
